export default __webpack_public_path__ + "static/media/imgForm.4b0d4bd9.jpg";